import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { SelectMultiple, BubbleContent } from 'tea-component';
import IconDom from '@/pages/intelligence/components/SelectCompoenet/ItemDom/IconDom';
import './index.scss';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { useIntl } from 'umi';
import { renderButtonUI } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/VisualMetricSelectorDual';

const VisuailsMetricSelector = (props: any) => {
  const { options, visuailsMetricValues, setVisuailsMetricValues, disabled, useAllSelectedOptionsDisplay = false } = props;

  // const { formatMessage } = useIntlExtend();
  const { formatMessage } = useIntl(); // 中英切换方法

  // 指标下拉筛选器：仅展示已本地化的指标名，不再拼接数据源前缀
  // （数据源前缀只用于折线图 legend，参见 PCUPhysicalDigital/index.tsx）
  const optionsSelect = options?.map((e: any) => {
    const isDisabled = visuailsMetricValues?.length > 1 && (!visuailsMetricValues?.includes(e?.value));
    const displayText = formatMessage({ id: e?.text || e?.value });
    return {
      value: e?.value,
      text: (
        <IconDom
          data={{
            text: displayText,
            img: getDataSourceIcon(e?.icon ? e.icon: (e?.dataSource || e?.value)),
          }}
        />
      ),
      //勾选2个值时，其他指标不让勾选
      disabled: isDisabled,
      tooltip: isDisabled ?
        <BubbleContent placement="bottom-start" dark>  <span>
          {formatMessage({ id: 'dbi_info_all_metrics_disabled' })}</span>
        </BubbleContent> : null,
    };
  });

  return (
    <>
      <div className={classnames('dbi-metric-card-right', { 'dbi-metric-card-right--new': useAllSelectedOptionsDisplay })}>
        <SelectMultiple
          className="dbi-metric-card-select"
          overlayClassName="dbi--allmetric-overlay"
          options={optionsSelect}
          disabled={disabled}
          appearance="button"
          matchButtonWidth
          size="l"
          value={visuailsMetricValues}
          staging={false}
          onChange={(value) => {
            if (!value.length) {
              setVisuailsMetricValues?.([...visuailsMetricValues])
            } else {
              const sortOrderArray = (arr: string[] = [], orderArr: any[] = []) => {
                // 通过 'reduce' 和 'filter' 将 'orderArr' 中元素的顺序应用到 'arr'
                return orderArr?.reduce((acc, t) => {
                  // 使用 'filter' 从 'arr' 中找出和 'val' 相等的元素
                  let matchingVals = arr?.filter(arrVal => arrVal === t?.value);
                  // 将找出的元素添加到结果数组 'acc'
                  return acc.concat(matchingVals);
                }, []);
              }
              //对勾选的指标按列表项进行排序
              setVisuailsMetricValues?.(sortOrderArray(value, options))
            }
          }}
          button={(options) => (
            <div className="dbi-metric-result">
              <div className="dbi-metric-result-lable">
                {formatMessage({ id: 'dbi_label_metrics' })}
              </div>
              <div className="dbi-metric-result-text">
                {useAllSelectedOptionsDisplay && (
                  <div className="dbi-metric-result-value">{renderButtonUI(formatMessage, options)}</div>
                )}
                {useAllSelectedOptionsDisplay || (
                  <div className="dbi-metric-result-value">
                    {options.length
                      ? options?.map((e, index) => {
                        return (
                          <span
                            className="dbi-metric-result-span"
                            key={e?.text + e?.value}
                          >
                            {e?.text}
                            {index !== options?.length - 1 && <>,&nbsp;</>}
                          </span>
                        );
                      })
                      : formatMessage({ id: 'dbi_please_select' })
                    }
                  </div>
                )}
              </div>
            </div>
          )}
        />
      </div>
    </>
  );
};

export default VisuailsMetricSelector;
